module.exports = __webpack_public_path__ + "static/media/collection-room.39d00614.png";